import script from "./ServiceWorker.vue?vue&type=script&lang=ts"
export * from "./ServiceWorker.vue?vue&type=script&lang=ts"

export default script